import { inlineTextInputKey } from './';
export var createInlineTextInputDriver = function (wrapper) {
    var base = wrapper.$("." + inlineTextInputKey);
    return {
        getDisplayedText: function () { return base.text(); },
        getValue: function () { return base.$('input').value(); },
        setValue: function (value) { return base.$('input').enterValue(value); },
        disabled: function () { return base.hasClass('disabled'); },
        onHover: function () { return base.hover(); },
        clickToEdit: function () { return base.click(); },
        showingInput: function () { return base.$('.input-container').exists(); },
        clickClear: function () { return base.$('.clear-button').click(); },
        isClearDisabled: function () { return base.$('.clear-button.disabled').exists(); },
        clickConfirm: function () { return base.$('.confirm-button').click(); },
        isConfirmDisabled: function () { return base.$('.confirm-button.disabled').exists(); },
        clickCancel: function () { return base.$('.cancel-button').click(); },
        isCancelDisabled: function () { return base.$('.cancel-button.disabled').exists(); },
        isValidationError: function () { return base.$('.inline-text-error').exists(); },
        isLoading: function () { return base.$('.tiny-loader').exists(); },
        isDisabled: function () { return base.$('.unfocused-body').hasClass('disabled'); },
        isFocused: function () { return base.$('.focused-body').exists(); },
        base: base,
    };
};
//# sourceMappingURL=driver.js.map